if (!window.direct) {
    window.direct = {};
}

window.direct.getPosition = function (el, rel) {
    let x = 0, y = 0;
    do {
        x += el?.offsetLeft || 0;
        y += el?.offsetTop || 0;
        el = el?.offsetParent;
    } while (el && el !== rel);

    return {x: x, y: y};
};

window.direct.selectText = element => {
    if (document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    }
};

window.direct.fetchAndUpdateCaptcha = () => {
    const captchaImages = document.querySelectorAll(".signup-captcha");
    const captchaTextFields = document.querySelectorAll(".captchaText");
    const keyFields = document.querySelectorAll(".key");

    fetch("/app/service/signup/captcha")
        .then(response => response.json())
        .then(data => {
            captchaImages.forEach(img => {
                img.setAttribute("src", data.imageData);
            });

            captchaTextFields.forEach(field => {
                field.value = data.captchaText;
            });

            keyFields.forEach(field => {
                field.value = data.key;
            });
        });
};

// Wrap an HTMLElement around another HTMLElement or an array of them.
HTMLElement.prototype.wrapAll = function(elms) {
    // Convert single element to array for consistent handling
    const elements = elms.length !== undefined ? elms : [elms];
    const el = elements[0];

    // Cache the current parent and sibling of the first element.
    const parent = el.parentNode;
    const sibling = el.nextSibling;

    // Wrap the first element (is automatically removed from its
    // current parent).
    this.appendChild(el);

    // Wrap all other elements (if applicable). Each element is
    // automatically removed from its current parent.
    for (let i = 1; i < elements.length; i++) {
        this.appendChild(elements[i]);
    }

    // If the first element had a sibling, insert the wrapper before the
    // sibling to maintain the HTML structure; otherwise, just append it
    // to the parent.
    if (sibling) {
        parent.insertBefore(this, sibling);
    } else {
        parent.appendChild(this);
    }
};

